import { postRequest } from '../../services/api';
import type { ApiResponse } from '../../services/types';
import { devError } from '../../utils/log';
import type { LaunchGameRequest, LaunchGameResponse } from '../game/types';

export async function postLaunchGame({ gameId, coin, type }: LaunchGameRequest) {
  const response = await postRequest<ApiResponse<LaunchGameResponse>>('user/launch-game', {
    gameId,
    coin,
    type,
  });

  return response.data.data;
}

export async function addPlayerToFrb(bonusCode: string) {
  try {
    await postRequest(`gift/addPlayersToFRB`, { bonusCode });
    return true;
  } catch (e) {
    devError('Failed to add player to FRB', e);
    return false;
  }
}
